import React, {useEffect, useState} from 'react'
import {useTheme} from '@mui/material'
import {css} from '@emotion/react'
import {log} from 'common/log'
import {CloudOff} from '@mui/icons-material'

const cssRoot = css`
	position: fixed;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 160px;
	margin-left: -57px; /* Negative half of width. */
	height: 35px;
	top: -100px;
	left: 50%;
	border-radius: 6px;
	box-shadow: 0 0 25px 4px #000000;
	transition: top 0.5s ease-in-out;
	z-index: 99999999;
	color: white;
	font-weight: bold;
	user-select: none;

	&:hover {
		opacity: 0.6;
	}
`
const cssIsOffline = css`
	top: 10px;
`

export const NetworkStatusComponent = React.memo(function NetworkStatusComponent() {
	const theme = useTheme()
	const cssColor = css`
		background: ${theme.palette.error.main};
	`
	const [offline, setOffline] = useState(false)
	useEffect(() => {
		const setOff = () => {
			log.error('Offline!')
			setOffline(true)
		}
		const setOn = () => {
			log.error('Online!')
			setOffline(false)
		}
		window.addEventListener("offline", setOff);
		window.addEventListener("online", setOn);
		return () => {
			window.removeEventListener("offline", setOff);
			window.removeEventListener("online", setOn);
		}
	}, []);
	return <div className={'NetworkStatusComponent'} css={[cssRoot, cssColor, offline ? cssIsOffline : undefined]}>
		<CloudOff/>&nbsp;&nbsp;Offline
	</div>
})